import axios from "../axios";

// 🤝 Codes des partenaires (tour 54), sans connexion : vérification d'un code tapé, visite arrivée
// par un lien (une par chargement du site)
const Partners = {
  // { code, public_name } ; code inconnu ou suspendu : erreur 404
  check(code) {
    return axios.get(`/partner-codes/${encodeURIComponent(String(code).trim())}`).then(({ data }) => data?.data);
  },
  // { code, public_name, active } ; code inconnu : erreur 404
  visit(code) {
    return axios.post(`/partner-codes/${encodeURIComponent(String(code).trim())}/visits`).then(({ data }) => data?.data);
  },
};

export default Partners;
